import React, { Component } from 'react';

const style = {
    selector: {width: "30%", height: 35, margin: 10}
};

class PackageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {menuItems: [], items: this.props.items, showAddItem: false,
            selectedItem: this.props.items.length>0?this.props.items[0]:null,
            canRepeat: this.props.canRepeat,
            quantity: this.props.quantity};
        this.selectCategory = this.selectCategory.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.addComponentItem = this.addComponentItem.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.changeSelectedItem = this.changeSelectedItem.bind(this);
        this.componentQuantityChange = this.componentQuantityChange.bind(this);
        this.canRepeatChange = this.canRepeatChange.bind(this);
    }

    changeSelectedItem(event) {
        const item = this.state.items.find(item => item.name === event.target.value);
        console.log('change selected item', item);
        this.setState({selectedItem: item});
    }

    selectCategory(event) {
        console.log("category selected", event.target.value);
        const items = this.props.onSelectCategory(event.target.value);
        console.log("menu items are", items);
        this.setState({menuItems: items});
    }

    selectItem(event) {
        const item = this.state.menuItems.find(item => item.id === event.target.value);
        console.log("selected item ", item);
        this.setState({selectedItem: item});
    }

    addComponentItem() {
        console.log("add component item", this.state.selectedItem);
        if (!this.state.items.find(item => item.id.toString() === this.state.selectedItem.id)) {
            const items = [this.state.selectedItem].concat(this.state.items);
            this.setState({items: items});
            this.props.onComponentUpdate({name: this.props.name, items: items,
                quantity: this.state.quantity, canRepeat: this.state.canRepeat});
        }
    }

    deleteItem() {
        console.log("delete component item", this.state.selectedItem);
        const selectedItem = this.state.selectedItem;
        const items = this.state.items.filter(item => item.name !== selectedItem.name);
        this.setState({selectedItem: null, items: items});
        this.props.onComponentUpdate({name: this.props.name, items: items});
    }

    componentQuantityChange(e) {
        console.log('quantity change', e.target.value);

        if(e.target.value === '') {
            this.setState({quantity: e.target.value});
            return
        }

        const quantity = parseInt(e.target.value);

        if(isNaN(quantity)) {
            alert("请输入数字");
        } else if(quantity<1) {
            alert("请输入大于0的数字");
        } else {
            this.setState({quantity: quantity});
            this.props.onComponentUpdate({name: this.props.name, items: this.props.items,
                quantity: quantity, canRepeat: this.state.canRepeat});

        }
    }

    canRepeatChange(e) {
        this.setState({canRepeat: e.target.checked});
        this.props.onComponentUpdate({name: this.props.name, items: this.state.items,
            quantity: this.state.quantity, canRepeat: e.target.checked});
    }

    render() {
        const categories = [{name: "-", id: null}].concat(this.props.categories).map(
            cat => <option key={cat.id} style={style.selector} value={cat.id}>{cat.name}</option>);
        const menuItems = [{name: "-", id: null}].concat(this.state.menuItems).map(
            item => <option key={item.id} value={item.id}>{item.name}</option>);

        const addItemRow = this.state.showAddItem ? (
            <div style={{borderBottom: "1px solid gainsboro"}}>
                <span>类别</span>
                <select name="category" onChange={this.selectCategory} style={style.selector}>
                    {categories}
                </select>
                <span>餐品</span>
                <select name="menuItem" onChange={this.selectItem} style={style.selector}>
                    {menuItems}
                </select>
                <span style={{marginRight: 15}} className="btn btn-primary"
                      onClick={this.addComponentItem}>
                    确认
                </span>
            </div>) : null;

        const deleteItemButton = this.state.items.length < 1 || this.state.showAddItem ? null :
            (<span style={{marginRight: 15}}
                   className="btn btn-default"
                   onClick={this.deleteItem}
            >
                    删除
                </span>);

        return (
            <div style={{borderTop: '1px solid gainsboro', marginTop: 5}}>
                <div>
                    <img src={require('../../../images/pos/deleteNoteImg.png')}
                         style={{marginRight: 10}}
                         onClick={() => this.props.onDelete(this.props.name)}
                    />
                    <span style={{
                        width: 150,
                        textAlign: "left",
                        fontWeight: 'bold',
                        marginRight: 10
                    }}>{this.props.name}</span>
                    <div>
                        <span style={{marginLeft: 10}}>餐品列表</span>
                        <select
                            style={{height: 35, width: 150, margin: "10px 15px"}}
                            onChange={this.changeSelectedItem}>
                            {this.props.items.map((item, i) => <option key={i}>{item.name}</option>)}
                        </select>
                        <span
                            style={{marginRight: 10}}>{this.props.items.length > 0 ? "(" + this.props.items.length + ")" : ''}</span>
                        <span
                            style={{marginRight: 15}}
                            className="btn btn-primary"
                            onClick={() => this.setState({showAddItem: !this.state.showAddItem})}
                        >
                            {this.state.showAddItem ? '完成添加' : '添加'}
                        </span>
                        {deleteItemButton}
                    </div>
                </div>
                {addItemRow}
                <div>
                    <span style={{marginLeft: 10}}>可选数量</span>
                    <input
                        style={{width: 145, display: 'inline', marginLeft: 20}}
                        type="text"
                        defaultValue={this.state.quantity}
                        value={this.state.quantity}
                        className="form-control input-lg componentName"
                        placeholder=""
                        onChange={this.componentQuantityChange}/>
                </div>
            </div>);
    }
}

export default class PackgeCreator extends Component {
    constructor(props) {
        super(props);
        if (this.props.package) {
            const components = this.props.package.items.map(i => ({name: i.name, items: i.options, canRepeat: i.canRepeat, quantity: i.quantity}));
            this.state = {
                currentComponent: {name: '', items: []},
                components: components,
                menuItems: [],
                compName: ''
            };
        } else {
            this.state = {currentComponent: {name: '', items: []}, components: [], menuItems: [], compName: ''};
        }

        this.componentNameChange = this.componentNameChange.bind(this);
        this.addComponent = this.addComponent.bind(this);
        this.deleteComponent = this.deleteComponent.bind(this);
        this.componentUpdate = this.componentUpdate.bind(this);
    }

    addComponent() {
        console.log("add component ", this.state.compName);
        const name = this.state.compName;
        const sameName = this.state.components.filter(c => c.name === name);

        if (!name || name.trim() === '') {
            this.setState({error: "请输入选项名称"});

        } else if (sameName.length > 0) {
            this.setState({error: "套餐选项'" + name + "'已经创建，名称不能重复"});
        } else {
            const newComponents = this.state.components.concat({name: name, items: []});
            this.setState({components: newComponents, compName: '', error: null});
            this.props.onPackageUpdate({components: newComponents});
        }
    }

    componentNameChange(e) {
        this.setState({compName: e.target.value});
    }

    deleteComponent(name) {
        const newComponents = this.state.components.filter(c => c.name !== name);
        this.setState({components: newComponents});
        this.props.onPackageUpdate({components: newComponents});
    }

    componentUpdate(comp) {
        console.log("component update! ", comp);
        this.state.components.splice(this.state.components.findIndex(c => c.name == comp.name),1,comp);
        const newComponents = this.state.components;
        this.setState({components: newComponents});
        this.props.onPackageUpdate({components: newComponents});
    }

    render() {
        console.log("rendering package creator ", this.props);
        const components = this.state.components.map((comp, i) =>
            <PackageComponent
                key={i}
                {...comp}
                onDelete={this.deleteComponent}
                categories={this.props.categories}
                onSelectCategory={this.props.onSelectCategory}
                onComponentUpdate={this.componentUpdate}
            />);

        return (
            <div style={{padding: 10}} className="form-group">
                <div style={{color: 'red'}} className="has-error">{this.state.error}</div>
                <div className="row">
                    <div className="addComponentRow">
                        <div>
                            <input
                                style={{width: 370, display: 'inline', marginRight: 20}}
                                type="text"
                                value={this.state.compName}
                                className="form-control input-lg componentName"
                                placeholder="套餐选项名称，例如：前菜"
                                onChange={this.componentNameChange}/>
                            <div className="btn btn-primary addComponent"
                                 onClick={this.addComponent}>
                                添加类别
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{marginTop: 20, height: 400, overflowY: 'scroll'}} className="row components">
                    <div>套餐选项</div>
                    {components}
                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/settings/menu/PackageCreator.js